var exports = {
  "wx": "x61f99309--dd4c80--header",
  "h_": "x61f99309--dd4c80--description",
  "Ef": "x61f99309--dd4c80--description_mobile",
  "NH": "x61f99309--dd4c80--header_mobile",
  "VI": "x61f99309--dd4c80--footer_mobile",
  "Sl": "x61f99309--dd4c80--image",
  "qr": "x61f99309--dd4c80--footer",
};

module.exports = exports;
